import React from 'react';
import { JoinMethod } from '../../../lib/join-method/join-method';
import { Button } from '../Button';
import DialInInfo from '../../../app/shared/DialInInfo/DialInInfo';

import './ShowDialInInfoButton.scss';

export type ShowDialInInfoButtonProps = {
  joinMethod: JoinMethod;
  showDialInInfo: boolean;
  toggleDialInInfo: () => void;
}

const ShowDialInInfoButton: React.FunctionComponent<ShowDialInInfoButtonProps> = (props: ShowDialInInfoButtonProps): JSX.Element => {
  const {
    joinMethod,
    showDialInInfo,
    toggleDialInInfo,
  } = props;

  /* [OEP-30761] - for now always show the show/hide button for the AudioBrdige connection in group, ignoring the value of showHideButtonEnabled from Central */
  const showHideButtonEnabled = true;
  const showDialInInfoButtonLabel = joinMethod.showDialInInfo;
  const hideDialInInfoButtonLabel = joinMethod.hideDialInInfo;

  const isAudioBridgeType = joinMethod.isAudioBridgeType() || joinMethod.isUniqueDialInType();
  const displayShowDialInInfoButton = `connection-item__dial-in ${showDialInInfo ? 'block' : 'hidden'}`;
  const dialInfoButtonTitle = showDialInInfo ? hideDialInInfoButtonLabel : showDialInInfoButtonLabel;

  return (
    <div className='connection-item'>
      <div
        className={showHideButtonEnabled ? displayShowDialInInfoButton : ''}
      >
        <DialInInfo joinMethod={joinMethod}/>
      </div>
      {isAudioBridgeType && showHideButtonEnabled && (
        <Button
          className='connection-item__show-dial-button'
          name='toggle-dial'
          onClick={toggleDialInInfo}
        >
          {dialInfoButtonTitle}
        </Button>
      )}
    </div>
  );
};

export default ShowDialInInfoButton;
